import { ITEMS_ON_PAGE } from './constants';

export const getItemsByPage = <T>(currentPage: number, items: T[]): T[] =>
  items.slice(ITEMS_ON_PAGE * (currentPage - 1), ITEMS_ON_PAGE * currentPage);
